import {post, get} from 'Utils/apiUtil';
import {
    getProxyDeliveryOrderListUrl,
    getProxyDeliveryShipmentListUrl,
    receiveProxyDeliveryPackageUrl,
    viewProxyDeliveryShipmentListUrl,
    f1OrderListUrl,
    sysDictUrl,
    rejectProxyDeliveryPackageUrl,
} from 'Utils/urlUtil';

export const F1_PACKAGE_ON_THE_GO_ORDERLIST = 'F1_PACKAGE_ON_THE_GO_ORDERLIST';
export const UPDATEF1ORDERSEARCHLIST = 'UPDATEF1ORDERSEARCHLIST';
export const F1ORDER_RECEIVE_SEARCH_FIELD = 'F1ORDER_RECEIVE_SEARCH_FIELD';
export const F1ORDER_RECEIVE_DETAIL = 'F1ORDER_RECEIVE_DETAIL';
export const F1_ORDERLIST_SEARCH_FIELD = 'F1_ORDERLIST_SEARCH_FIELD';
export const UPDATE_F1_ORDER_LIST = 'UPDATE_F1_ORDER_LIST';
export const UPDATE_F1_PACKAGE_ON_THE_GO_LIST =
    'UPDATE_F1_PACKAGE_ON_THE_GO_LIST';
export const F1_ORDER_TAB_ACTIVE = 'F1_ORDER_TAB_ACTIVE';
export const SET_F1_ORDER_ON_GO_PACKAGE_SOURCE =
    'SET_F1_ORDER_ON_GO_PACKAGE_SOURCE';
export const UPDATE_F1_ORDER_ON_GO_PACKAGE_CURRENT_PAGE_NUM =
    'UPDATE_F1_ORDER_ON_GO_PACKAGE_CURRENT_PAGE_NUM';
export const UPDATE_F1_ONGO_PACKAGE_SORT = 'UPDATE_F1_ONGO_PACKAGE_SORT';

export const PROXY_DELIVERY_ORDER_LIST = 'PROXY_DELIVERY_ORDER_LIST';
export const PROXY_DELIVERY_PACKAGE_ORDER_LIST =
    'PROXY_DELIVERY_PACKAGE_ORDER_LIST';
export const UPDATE_PROXY_DELIVERY_ORDER_SEARCH_LIST =
    'UPDATE_PROXY_DELIVERY_ORDER_SEARCH_LIST';
export const UPDATE_PROXY_DELIVERY_PACKAGE_ORDER_SEARCH_LIST =
    'UPDATE_PROXY_DELIVERY_PACKAGE_ORDER_SEARCH_LIST';
export const UPDATE_PROXY_DELIVERY_PACKAGE_RECEIVE_SEARCH_LIST =
    'UPDATE_PROXY_DELIVERY_PACKAGE_RECEIVE_SEARCH_LIST';
export const UPDATE_PROXY_DELIVERY_ORDER_CURRENT_PAGE_NUM =
    'UPDATE_PROXY_DELIVERY_ORDER_CURRENT_PAGE_NUM';
export const UPDATE_PROXY_DELIVERY_PACKAGE_SORT =
    'UPDATE_PROXY_DELIVERY_PACKAGE_SORT';
export const SET_PROXY_DELIVERY_ORDER_SOURCE =
    'SET_PROXY_DELIVERY_ORDER_SOURCE';
export const UPDATE_PROXY_DELIVERY_ORDER_TAB_ACTIVE =
    'UPDATE_PROXY_DELIVERY_ORDER_TAB_ACTIVE';
export const VIEW_PROXY_DELIVERY_ORDER_PACKAGE =
    'VIEW_PROXY_DELIVERY_ORDER_PACKAGE';

export const CLEARE_PROXY_DELIVERY_PACKAGE_DATA =
    'CLEARE_PROXY_DELIVERY_PACKAGE_DATA';
export const REJECT_PROXY_DELIVERY_PACKAGE = 'REJECT_PROXY_DELIVERY_PACKAGE';
export const UPDATE_PROXY_DELIVERY_ORDER_LIST_DATA =
    'UPDATE_PROXY_DELIVERY_ORDER_LIST_DATA';
export const UPDATE_PROXY_DELIVERY_PACKAGE_LIST_DATA =
    'UPDATE_PROXY_DELIVERY_PACKAGE_LIST_DATA';
export const UPDATE_VIEW_RECEIVE_PACKAGE_DATA =
    'UPDATE_VIEW_RECEIVE_PACKAGE_DATA';
export const SYS_DICT = 'SYS_DICT';
export const REJECT_REASON_SYS_DICT = 'REJECT_REASON_SYS_DICT';

const isMock = true;

// Get Proxy Delivery orders
export const getProxyDeliveryOrderList = (data) => (dispatch) =>
    dispatch(
        post(isMock ? f1OrderListUrl : getProxyDeliveryOrderListUrl, data),
    ).then((res) => {
        dispatch({type: PROXY_DELIVERY_ORDER_LIST, payload: res});
        return res;
    });

// Get Proxy Delivery Package orders
export const getProxyDeliveryPackageOrderList = (data) => async (dispatch) => {
    try {
        const res = await dispatch(post(getProxyDeliveryShipmentListUrl, data));
        dispatch({type: PROXY_DELIVERY_PACKAGE_ORDER_LIST, payload: res});
        return res;
    } catch (error) {
        const emptyPayload = {
            status: 'error',
            pageNum: 0,
            total: 0,
            pageTotal: 0,
            data: [],
        };

        // Populate store with an empty list so downstream logic keeps working even on 404
        dispatch({
            type: PROXY_DELIVERY_PACKAGE_ORDER_LIST,
            payload: emptyPayload,
        });

        if (error && (error.status === 404 || error.status === '404')) {
            return emptyPayload;
        }

        return emptyPayload;
    }
};

// View Proxy Delivery Package
export const viewProxyDeliveryPackage = (params) => (dispatch) =>
    dispatch(post(viewProxyDeliveryShipmentListUrl, params)).then((res) => {
        dispatch({type: VIEW_PROXY_DELIVERY_ORDER_PACKAGE, payload: res});
        return res;
    });

// Proxy Delivery Receive Package
export const receiveProxyDeliveryPackage = (data) =>
    post(receiveProxyDeliveryPackageUrl, data);

// Reject Proxy Delivery Package
export const rejectProxyDeliveryPackage = (data) => (dispatch) =>
    dispatch(post(rejectProxyDeliveryPackageUrl, data)).then((res) => {
        dispatch({type: REJECT_PROXY_DELIVERY_PACKAGE, payload: res});
        return res;
    });

export const updateF1PackageOnTheGoList = (params) => ({
    type: UPDATE_F1_PACKAGE_ON_THE_GO_LIST,
    payload: params,
});

export const updateProxyDeliveryOrderListData = (params) => ({
    type: UPDATE_PROXY_DELIVERY_ORDER_LIST_DATA,
    payload: params,
});
export const updateViewReceivePackageData = (params) => ({
    type: UPDATE_VIEW_RECEIVE_PACKAGE_DATA,
    payload: params,
});

export const updateProxyDeliveryPackageListData = (params) => ({
    type: UPDATE_PROXY_DELIVERY_PACKAGE_LIST_DATA,
    payload: params,
});

// Update F1 Order Tab Active
export const clearProxyDeliveryPackageData = (params) => ({
    type: CLEARE_PROXY_DELIVERY_PACKAGE_DATA,
    payload: params,
});

export const updateProxyDeliveryOrderSearchFileld = (params) => ({
    type: UPDATE_PROXY_DELIVERY_ORDER_SEARCH_LIST,
    payload: params,
});

export const updateProxyDeliveryPackageOrderSearchList = (params) => ({
    type: UPDATE_PROXY_DELIVERY_PACKAGE_ORDER_SEARCH_LIST,
    payload: params,
});

export const updateProxyDeliveryPackageReceiveSearchFileld = (params) => ({
    type: UPDATE_PROXY_DELIVERY_PACKAGE_RECEIVE_SEARCH_LIST,
    payload: params,
});

// Update Proxy Delivery Order Page Number
export const updateProxyDeliveryOrderListPageNum = (params) => ({
    type: UPDATE_PROXY_DELIVERY_ORDER_CURRENT_PAGE_NUM,
    payload: params,
});

// Update Proxy Delivery Package Sort
export const updateProxyDeliveryPackageSort = (params) => ({
    type: UPDATE_PROXY_DELIVERY_PACKAGE_SORT,
    payload: params,
});

// Set Proxy Delivery Order Source
export const setProxyDeliveryOrderSource = (params) => ({
    type: SET_PROXY_DELIVERY_ORDER_SOURCE,
    payload: params,
});

// Update Proxy Delivery Order Tab Active
export const updateProxyDeliveryOrderTabActive = (params) => ({
    type: UPDATE_PROXY_DELIVERY_ORDER_TAB_ACTIVE,
    payload: params,
});

export function getSysDict(dictType) {
    return (dispatch) =>
        dispatch(get(sysDictUrl, {dictType})).then((res) => {
            dispatch({type: SYS_DICT, payload: res});
        });
}

export function getSysDictByRejectReason(dictType) {
    return (dispatch) =>
        dispatch(get(sysDictUrl, {dictType})).then((res) => {
            dispatch({type: REJECT_REASON_SYS_DICT, payload: res});
        });
}
